import axiosHttp from "../../config/axios.interceptor";
import { utilReducerConstant } from "../reducerConstant";
import { indiaCountryCode } from "../../shared/const.prop";

export const getCountryList = () => async (dispatch) => {
  const countries = await axiosHttp.get(`countries`);
  dispatch({
    type: utilReducerConstant.SET_COUNTRY_LIST,
    payload: countries?.data?.data || [],
  });
};

export const getStateList = (countryId) => async (dispatch) => {
  const stateList = await axiosHttp.get(
    `states?country_id=${countryId || indiaCountryCode}`
  );
  dispatch({
    type: utilReducerConstant.SET_STATE_LIST,
    payload: stateList?.data?.data || [],
  });
};

export const getLanguageList = () => async (dispatch) => {
  const languages = await axiosHttp.get(`languages`);
  dispatch({
    type: utilReducerConstant.SET_LANGUAGE_LIST,
    payload: languages?.data?.data || [],
  });
};

export const getCategoryList = () => async (dispatch) => {
  const categories = await axiosHttp.get(`skills-category`);
  dispatch({
    type: utilReducerConstant.SET_CATEGORY_LIST,
    payload: categories?.data || [],
  });
};
